/*eslint-disable */
import { ClickAwayListener, useMediaQuery, Tooltip } from '@mui/material';
import {
  UptimeGrid,
  UptimeOverlay
} from '@uptime/uptime-component';
import { msalInstance } from 'config/auth';
import { oktaAuth } from 'config/oktaAuth';
import { DIGITAL_ASSISTANT_CARD_KNOWLEDGE, PORTAL_VERSION } from 'constants/index';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BaseAction from 'redux/actions/baseAction';
import { RootState } from 'redux/store';
import AppService from 'services/app.service';
import DateUtils from 'utils/date';
import { getUserProfile } from 'utils/function';
import { EditPreferencePath } from 'utils/routes';
import { GenerateDataTranslation } from 'utils/translation';
import ContentLanguageSelector from '../ContentLanguageSelector';
import LogoutModal from '../LogoutModal';
import UserAvatar from '../UserAvatar';
import { BoxInfo } from './UserSection.style';
import { signOut } from 'config/oidcAuth';

export interface IUserSectionProps {
  color?: string;
  isMarketplace?: boolean;
  showUserName?: boolean;
  openMobileNavMenu?: boolean;
  onCloseMobileNavMenu?: () => void;
  isOpenLogoutModal?: boolean;
  setOpenLogoutModal?: React.Dispatch<React.SetStateAction<boolean>>;
  openOnBehalfModal?: () => void;
  isAuthenticated?: boolean;
  oidcAuthen?: any;
}

/**
 * Renders Request items for the Request section in the navigation
 * @param props
 */
const UserSection: React.FC<IUserSectionProps> = props => {
  const { t } = useTranslation(['topNav', 'home-accessibility']);
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state: RootState) => state.baseReducer);
  const [expanded, setExpanded] = useState(false);
  const [imgUserInfo, setImgUserInfo] = useState();
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [dataUser, setDataUser] = useState(currentUser);
  const { showUserName, openMobileNavMenu, onCloseMobileNavMenu, isOpenLogoutModal = false, openOnBehalfModal, setOpenLogoutModal, isAuthenticated, oidcAuthen } = props;
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const topNavTranslation = GenerateDataTranslation('topNav');
  const history = useHistory();
  const { generalConfig } = useSelector(
    (state: RootState) => state.configReducer,
  );
  const { isOnBehalf, pcOrderOBO, userOnBehalf } = useSelector(
    (state: RootState) => state.onBehalfReducer,
  );
  const isPcOrderOBO = pcOrderOBO?.isOnBehalf;
  const languageData = generalConfig?.supportLanguage;
  const isDesktopWidth = useMediaQuery('(min-width:900px)');


  useEffect(() => {
    setLogoutModalOpen(isOpenLogoutModal);
  }, [isOpenLogoutModal]);

  useEffect(() => {
    if(setOpenLogoutModal){
      setOpenLogoutModal(logoutModalOpen);
    }
  }, [logoutModalOpen]);

  useEffect(() => {
    if (!!currentUser) {
      setDataUser(currentUser);
    }
  }, [currentUser]);

  useEffect(() => {
    const userInfo = isOnBehalf ? userOnBehalf : dataUser;
    if (!userInfo) return;
    setImgUserInfo(userInfo?.photo || userInfo?.avatar);
  }, [dataUser?.email, isOnBehalf, userOnBehalf?.email]);

  const handleToggleOverlay = async () => {
    if (openMobileNavMenu) {
      onCloseMobileNavMenu?.();
      history.push(EditPreferencePath);
      return;
    }
    setExpanded(!expanded);
    if (expanded) return;

    try {
      setOverlayLoading(true);
      const userProfile = await getUserProfile(dataUser.email, dataUser.user_name, generalConfig?.queryUserByUserName);
      if (!!userProfile) {
        const newDataUser = { ...dataUser, ...userProfile };
        setDataUser(newDataUser);
        dispatch(BaseAction.setCurrentUser(newDataUser));
        setOverlayLoading(false);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleOpenOnBehalfModal = () => {
    openOnBehalfModal?.();
    setExpanded(false);
  };

  const enterKeyPress = (e: { keyCode: any;}) => {
    if (e.keyCode === 13) {
      handleToggleOverlay();
    }
  };

  return (
    <>
      {!!dataUser  && isAuthenticated && !dataUser?.lockedOut && (
        <ClickAwayListener onClickAway={() => setExpanded(false)}>
          <div>
            <BoxInfo tabIndex={0} aria-label={t('home-accessibility:userAvatar')} role='img' onKeyDown={(e) => enterKeyPress(e)} id="dv-usersection-boxinfo" onClick={handleToggleOverlay}>
              {/* {userNameAndLogo} */}
              <Tooltip title={isOnBehalf ? userOnBehalf?.first_name : dataUser.first_name} arrow tabIndex={-1}>
                <UptimeGrid alignItems="center">
                  <UserAvatar userData={isOnBehalf ? userOnBehalf : dataUser} imgUser={imgUserInfo} showUserName={showUserName} />
                </UptimeGrid>
              </Tooltip>
            </BoxInfo>
            {expanded && isDesktopWidth && (
              <UptimeOverlay
                loading={overlayLoading}
                userInfo={isOnBehalf ? userOnBehalf : dataUser}
                imgAvatar={imgUserInfo}
                language={<ContentLanguageSelector />}
                enabledLanguage={!!languageData?.active}
                verifiedDate={DateUtils.timetoXbyGMT(
                  dataUser.last_verified,
                )}
                handleLogout={() => setLogoutModalOpen(true)}
                locale={topNavTranslation?.overLay}
                openOnBehalfModal={handleOpenOnBehalfModal}
                isEnableActOnBehalf={generalConfig?.actOnBehalfEnabled}
                handleEdit={() => { setExpanded(false); history.push(EditPreferencePath); }}
                isOnBehalf={isOnBehalf}
                isPcOrderOBO={isPcOrderOBO}
                isLockedOutUser={dataUser?.lockedOut}
              />
            )}
          </div>
        </ClickAwayListener>
      )}

      <LogoutModal
        isModalOpen={logoutModalOpen}
        setIsModalOpen={setLogoutModalOpen}
        signOutFC={() => {
          if(oidcAuthen?.isAuthenticated){
            signOut();
          }
          else if (AppService.isAuthenticatedByAzure()) {
            msalInstance.logoutRedirect().catch((e: any) => {
              console.error(e);
            });
          } 
          else if (oktaAuth) oktaAuth.signOut();

          const currentVersion = localStorage.getItem(PORTAL_VERSION) || '';
          localStorage.clear();
          localStorage.setItem(PORTAL_VERSION, currentVersion);
          sessionStorage.removeItem(DIGITAL_ASSISTANT_CARD_KNOWLEDGE);
        }}
      />
    </>
  );
};

export default UserSection;
